import { useMemo } from 'react';
import useApiResult from './common/useApiResult';
import { getWeeklyCounts } from './promises/getWeeklyCounts';

function useGetWeeklyCounts(date: Date) {
  const capacityResult = useMemo(() => getWeeklyCounts(date), [date]);

  const { loading, error, result } = useApiResult(capacityResult);

  return { loading, error, counts: result };
}

export default useGetWeeklyCounts;
